<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت تامین کنندگان</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">تامین کنندگان</h5>
                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                    <button class="btn btn-link text-accent-light"
                                        @click="onAddsupplierClicked()"><i class="fa fa-plus"></i>
                                </button>
                            </div>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا آدرس را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="mysuppliers.length===0">
                                        <p class="text-center mt-3">هیچ تامین کننده ای ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>کد مشتری</th>
                                                <th>نام مشتری</th>
                                                <th>موبایل</th>
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in mysuppliers">

                                                <td class="text-nowrap">{{it.customerCode}}</td>
                                                <td class="text-wrap">{{it.fullName}}</td>
                                                <td class="text-nowrap">{{it.mobile}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>

                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal" v-if="showNewCustomer">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="supplierMode === 'create'">ثبت تامین کننده</h1>
                        <h1 v-else>ویرایش تامین کننده</h1>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد تامین کننده</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.customerCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.name">
                        </div>
                    </div>
                    <div class="col-lg-5 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام خانوادگی/شرکت</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.family">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد/شناسه ملی</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.nationalCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد اقتصادی</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.taxCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد پستی</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.postalCode">
                        </div>
                    </div>

                    <div class="col-lg-8 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">آدرس</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.address">
                        </div>
                    </div>

                     <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">ایمیل</span>
                            </div>
                            <input type="email" class="form-control" v-model="supplierModel.email">
                        </div>
                    </div>

                    <h4 class="col-12 text-center"> تلفن های تامین کننده</h4>
                    <div class="col-12 overflow-auto" style="max-height: 12rem;">
                        <table class="table table-hover table-striped mb-3">
                            <thead>

                            <tr>
                                <th class="text-center text-nowrap">نام انبار/بخش</th>
                                <th class="text-center text-nowrap">نام مسئول مربوطه</th>
                                <th class="text-center text-nowrap">تلفن همراه</th>
                                <th class="text-center text-nowrap">تلفن ثابت</th>
                                <th class="text-center text-nowrap">ایمیل</th>


                            </tr>

                            </thead>
                            <tbody>
                            <tr v-for="item in customerPhone" v-if="item.customerId>0">
                                <td class="text-center text-nowrap">{{item.departmentName}}</td>
                                <td class="text-center text-nowrap">{{item.customeremployeeFullName}}</td>
                                <td class="text-center text-nowrap">{{item.cellPhoneNumber}}</td>
                                <td class="text-center text-nowrap">{{item.phoneNumber}}</td>
                                <td class="text-center text-nowrap">{{item.customerEmailAddress}}</td>


                            </tr>


                            </tbody>
                        </table>


                    </div>




                    <div class="col-lg-12  text-center">
                        <!--<button class="btn btn-success btn-round clickable mt-3 mx-3"-->
                                <!--@click="newsupplier">تامین کننده جدید-->
                        <!--</button>-->
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatesupplier" v-if="supplierMode=='edit'">ویرایش اطلاعات تامین کننده
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createsupplier" v-else>ثبت اطلاعات تامین کننده
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3 mx-3"
                                @click="newsupplierPhone">ثبت تلفن های تامین کننده
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelsupplier">بازگشت
                        </button>
                    </div>
                </div>
            </modal>
            <!--////////////////////////////////////////////تلفن جدید////////////////////////////////////-->
            <modal show="false" ref="insertModal" v-if="showNewCustomerPhone">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 >ثبت تلفن های تامین کننده </h1>
                        <h1 >{{this.supplierModel.name + " " + this.supplierModel.family}}</h1>
                    </div>


                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام انبار/بخش</span>
                            </div>
                            <input class="form-control" v-model="customerPhoneModel.departmentName">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام مسئول انبار/بخش</span>
                            </div>
                            <input class="form-control" v-model="customerPhoneModel.customeremployeeFullName">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره همراه</span>
                            </div>
                            <input type="number" class="form-control" v-model="customerPhoneModel.cellPhoneNumber">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره ثابت</span>
                            </div>
                            <input type="number" class="form-control" v-model="customerPhoneModel.phoneNumber">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">ایمیل</span>
                            </div>
                            <input type="email" class="form-control" v-model="customerPhoneModel.customerEmailAddress">
                        </div>
                    </div>



                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">آدرس انبار/بخش</span>
                            </div>
                            <input class="form-control" v-model="customerPhoneModel.wareHouseAddress">
                        </div>
                    </div>
                    <h4 class="col-12 text-center"> تلفن های تامین کننده</h4>
                    <div class="col-12 overflow-auto" style="max-height: 12rem;">
                        <table class="table table-hover table-striped mb-3">
                            <thead>

                            <tr>
                                <th class="text-center text-nowrap">نام انبار/بخش</th>
                                <th class="text-center text-nowrap">نام مسئول مربوطه</th>
                                <th class="text-center text-nowrap">تلفن همراه</th>
                                <th class="text-center text-nowrap">تلفن ثابت</th>
                                <th class="text-center text-nowrap">ایمیل</th>
                                <th class="text-center">عملیات</th>

                            </tr>

                            </thead>
                            <tbody>
                            <tr v-for="item in customerPhone" v-if="item.customerId>0">
                                <td class="text-center text-nowrap">{{item.departmentName}}</td>
                                <td class="text-center text-nowrap">{{item.customeremployeeFullName}}</td>
                                <td class="text-center text-nowrap">{{item.cellPhoneNumber}}</td>
                                <td class="text-center text-nowrap">{{item.phoneNumber}}</td>
                                <td class="text-center text-nowrap">{{item.customerEmailAddress}}</td>
                                <td class="text-center text-nowrap"><i
                                        class="fa fa-pencil-square-o px-3 clickable"
                                        style="font-size: larger"
                                        @click="editPhoneItem(item)"
                                        title="ویرایش آیتم"></i>
                                    | <i class="fa fa-trash-o px-3 clickable"
                                         style="font-size: larger"
                                         @click="deletePhoneItem(item)"
                                         title="حذف آیتم"></i>
                                </td>

                            </tr>


                            </tbody>
                        </table>


                    </div>


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updateCustomerPhone" v-if="customerphoneMode=='edit'">ویرایش تلفن
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createCustomerPhone" v-else>ثبت تلفن
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelCustomerPhone">بازگشت
                        </button>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "suppliers",
        components: {VsSelect, DatePicker},
        data() {
            return {

                showArchive: false,
                isSending: false,
                isLoading: false,
                mysuppliers: [],

                supplierMode: "",
                supplierModel: {
                    id: 0,
                    customerCode : "",
                    name: "",
                    family: "",
                    fullName: "",
                    fatherName: "",
                    mobile: "",
                    phone : "",
                    address: "",
                    postalCode :"",

                    email : "",
                    birthday :"",
                    nationalCode : "",
                    taxCode : "",
                    companeyId : 0,
                    customerType : 1,



                },
                search: "",
                supplierDocuments: [],
                supplierDocumentMode: "",
                supplierDocumentModel: {
                    name: "",
                    description: "",
                    address: "",
                    extention: "",
                    version: 0,
                    customerId: 0,
                },
                newImageCliked:false,
                showVersions: false,
                birthDay:"",
                customerPhone :[{
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                }],
                customerPhoneShow :[{
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",
                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                    showName :""
                }],
                customerPhoneModel : {
                    id :0,
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                },

                showNewCustomerPhone : false,
                showNewCustomer:true,
                customerphoneMode : "create",
            }
        },
        mounted() {
            this.getMysuppliers();

        },
        methods: {


            onAddsupplierClicked() {
                this.supplierModel = {
                    id: 0,
                    customerCode : "",
                    name: "",
                    family: "",
                    fullName: "",
                    fatherName: "",
                    mobile: "",
                    phone : "",
                    address: "",
                    postalCode :"",

                    email : "",
                    birthday :"",
                    nationalCode : "",
                    taxCode : "",
                    companeyId : 0,
                    customerType : 1,

                };
                this.customerPhone =[{
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                }],
                this.showNewCustomer=true;
                this.showNewCustomerPhone=false;
                this.supplierMode = "create";
                new BaseService("supplier", "/GetLastSupplierCode").getList().then(response =>{
                    this.supplierModel.customerCode = response.data+1;


                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.$refs.insertModal.showModal();
            },
            newsupplierPhone() {


                if (this.supplierModel.id === null || this.supplierModel.id === '' ||this.supplierModel.id === 0) {
                    Utils.handleErrorWithNotification("ابتدا اطلاعات  تامین کننده را ذخیره نمائید", this.$noty);
                    return;

                }
                this.showNewCustomer=false;
                this.showNewCustomerPhone = true;

                this.customerPhone = {
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                    showName: ""
                },
                    this.customerPhoneModel = {
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: "",
                    },
                    this.customerphoneMode = "create";
                this.getCustomerPhone();
                this.$refs.insertModal.showModal();

            },
            getCustomerPhone() {
                new BaseService("customerPhone", `/GetCustomerPhoneByCostumerId/${this.supplierModel.id}`).getList().then(response => {
                    this.customerPhone = response.data;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            updateCustomerPhone() {

                this.isSending = true;
                if((this.customerPhoneModel.cellPhoneNumber===null || this.customerPhoneModel.cellPhoneNumber.length===0) &&
                    (this.customerPhoneModel.phoneNumber===null || this.customerPhoneModel.phoneNumber.length===0))
                {
                    Utils.handleErrorWithNotification("لطفا یک شماره تلفن یا شماره تلفن همراه وارد کنید", this.$noty);
                    this.isSending = false;
                }

                new BaseService("CustomerPhone", "/UpdateCustomerPhone").update(this.customerPhoneModel).then(response => {
                    this.$noty.success("اطلاعات تماس تامین کننده با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.customerphoneMode = "create";
                    this.customerPhoneModel = {
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: "",
                    };

                    this.getCustomerPhone();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);


                });


            },
            createCustomerPhone() {
                this.isSending = true;
                if((this.customerPhoneModel.cellPhoneNumber===null || this.customerPhoneModel.cellPhoneNumber.length===0) &&
                    (this.customerPhoneModel.phoneNumber===null || this.customerPhoneModel.phoneNumber.length===0))
                {
                    Utils.handleErrorWithNotification("لطفا یک شماره تلفن یا شماره تلفن همراه وارد کنید", this.$noty);
                    this.isSending = false;
                }

                this.$refs.insertModal.showModal();
                this.customerPhoneModel.customerId = this.supplierModel.id;
                new BaseService("customerPhone", "/CreateCustomerPhone").create(this.customerPhoneModel).then(response => {
                    this.$noty.success("اطلاعات تماس تامین کننده با موفقیت ثبت شد");
                    this.isSending = false;
                    this.customerPhoneModel = {
                        id: 0,
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: "",
                    };

                    this.getCustomerPhone();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);

                });


            },
            cancelCustomerPhone() {
                this.isSending = false;
                this.showNewCustomer = true;
                this.showNewCustomerPhone = false;
                this.$refs.insertModal.showModal();

            },
            editPhoneItem(item) {
                if (item) {
                    this.customerPhoneModel = {
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: ""
                    };
                    this.customerPhoneModel.id = item.id;
                    this.customerPhoneModel.customerId = item.customerId;
                    this.customerPhoneModel.description = item.description;
                    this.customerPhoneModel.cellPhoneNumber = item.cellPhoneNumber;
                    this.customerPhoneModel.phoneNumber = item.phoneNumber;

                    this.customerPhoneModel.customeremployeeFullName = item.customeremployeeFullName;
                    this.customerPhoneModel.customerEmailAddress = item.customerEmailAddress;
                    this.customerPhoneModel.departmentName = item.departmentName;
                    this.customerPhoneModel.wareHouseAddress = item.wareHouseAddress;
                    this.customerphoneMode = "edit";
                }
            },
            deletePhoneItem(item) {
                if (item) {
                    if (confirm("آیا از حذف این شماره تلفن اطمینان دارید؟")) {

                        new BaseService("CustomerPhone", "DeleteCustomerPhone").delete(item.id).then(response => {
                            Utils.handleErrorWithNotification("این شماره تلفن با موفقیت حذف شد", this.$noty);
                            this.getCustomerPhone();
                        }).catch(error => {
                            Utils.handleErrorWithNotification(error, this.$noty);
                        })
                    }
                }

            },
            newsupplier(){
                new BaseService("supplier", "/GetLastSupplierCode").getList().then(response =>{
                    this.supplierModel.customerCode = response.data+1;


                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.supplierModel = {
                    id: 0,
                    customerCode : "",
                    name: "",
                    family: "",
                    fullName: "",
                    fatherName: "",
                    mobile: "",
                    phone : "",
                    address: "",
                    postalCode :"",

                    email : "",
                    birthday :"",
                    nationalCode : "",
                    taxCode : "",
                    companeyId : 0,
                    customerType : 1,

                };
                this.showNewCustomerPhone=false;
                this.getCustomerPhone();
                this.supplierMode = "create";


            },
            getMysuppliers() {
                new BaseService("supplier", "/Getsupplier").getList().then(response => {
                    this.mysuppliers = response.data;
                    this.isLoading = true;
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                this.supplierModel = item;
                this.supplierMode = "edit";
                this.getCustomerPhone();
                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("supplier", "Deletesupplier").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMysuppliers();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updatesupplier() {
                this.isSending = true;
                if ((this.supplierModel.name + this.supplierModel.family) === null || this.supplierModel.family.length===0 ) {
                    Utils.handleErrorWithNotification("لطفا نام خانوادگی/نام شرکت تامین را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if(this.supplierModel.customerCode == null || this.supplierModel.customerCode.length===0){
                    Utils.handleErrorWithNotification("لطفا کد تامین را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }

                new BaseService("supplier", "/Updatesupplier").update(this.supplierModel).then(response => {
                    this.$noty.success("تامین کننده با موفقیت ویرایش شد");
                    this.isSending = false;

                    this.getMysuppliers();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMysuppliers();
                });


            },
            createsupplier() {
                this.isSending = true;
                if ((this.supplierModel.name + this.supplierModel.family) === null  || this.supplierModel.family.length === 0) {
                    Utils.handleErrorWithNotification("لطفا نام خانوادگی/نام شرکت تامین کننده را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if(this.supplierModel.customerCode === null || this.supplierModel.customerCode.length===0) {
                    Utils.handleErrorWithNotification("لطفا کد تامین کنند را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }

                new BaseService("supplier", "/Createsupplier").create(this.supplierModel).then(response => {
                    this.$noty.success("تامین کننده با موفقیت ثبت شد");
                    this.isSending = false;
                    this.getMysuppliers();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.getMysuppliers();
                });

            },
            cancelsupplier() {
                this.$refs.insertModal.hideModal();
                this.getMysuppliers();
            },

            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("supplier", `/Searchsupplier/${this.search}`).getList().then(response => {
                        this.mysuppliers = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMysuppliers();
                }
            },

            onCreateDatePicked(val) {
                this.birthDay = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.supplierModel.birthday = this.jalaliToGregorian(val);

            },
            toggleCreateDatePicker() {
                this.$refs.birthDay.togglePicker();
            },



        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>